const CommandCenter = ({ data }) => {
  if (!data) return null;

  const tooltips = [
    "Instead of juggling multiple spreadsheets and folders, everything lives in ONE place! From start to finish, you can see exactly where everything is and what needs to happen next.",
    "No more staring at blank documents! Tell the AI what you need, and it creates a professional first draft that follows all the rules. You just review and polish it.",
    "This is your rule checker! It's like having a compliance officer review everything to make sure you don't accidentally break any FAR/DFARS rules - and it explains WHY something might be an issue.",
    "Tired of hunting through emails for submissions? This creates a clean, organized system where vendors submit everything in the right format, and you can find it instantly.",
    "Every AI suggestion comes with receipts! You can click and see exactly what document or data made the AI recommend something - total transparency.",
    "Stop rebuilding the wheel! Your documents connect directly to your existing files and systems, so information flows automatically without manual copying.",
    "Save your successful approaches! When you figure out a good way to do something, save it as a template so your whole team can use that winning formula next time."
  ];

  return (
    <section className="py-16 px-6" data-testid="command-center-section">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            {data.title.split('Ready-to-Run Acquisition Command Center')[0]}
            <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              Ready-to-Run Acquisition Command Center
            </span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-4xl mx-auto">
            {data.subtitle}
          </p>
        </div>

        <div className="bg-gradient-to-br from-purple-600/20 to-blue-600/10 rounded-3xl p-1 shadow-xl">
          <div className="bg-white rounded-3xl p-8 lg:p-12 border border-gray-200">
            <div className="hidden lg:grid grid-cols-2 gap-8 text-xs font-bold uppercase tracking-wider text-gray-500 border-b border-gray-200 pb-4 mb-6">
              <div className="text-purple-700">What teams need</div>
              <div className="text-purple-700">How AcuSightPro delivers</div>
            </div>

            <div className="space-y-8">
              {data.features.map((feature, index) => (
                <div
                  key={index}
                  className="grid lg:grid-cols-2 gap-6 pb-6 border-b border-gray-100 last:border-0"
                  data-testid={`command-feature-${index}`}
                  data-robot-tooltip={tooltips[index]}
                >
                  <div className="font-semibold text-gray-900">
                    {feature.question}
                  </div>
                  <div className="text-gray-600">
                    {feature.answer}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommandCenter;
